// The  amend column/logic and the buttons are commented as we are unsure if the clinet requires it

import Checkbox from "@material-ui/core/Checkbox";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import { connect } from "react-redux";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";

import React, { useEffect, useState } from "react";
import ConfirmModal from "./ConfirmModal";
import { t1HeadCells } from "./T1Headcells";

import { readableDateTime } from "../../functions/timeFormat";

import EnhancedTableHead from "./EnhancedTableHead";
import EnhancedTableToolbar from "./EnhancedTableToolbar";

const ClientTimesheetTable = ({
  timesheets,
  userToken,
  useStyles,
  pendingPlacements,
  dispatch,
}) => {
  const [showModal, setShowModal] = useState({
    show: false,
    status: "Pending",
    multiple: false,
    isClient: false,
  });
  const classes = useStyles();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);

  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [refresh, setRefresh] = React.useState(false);

  const [state, setState] = useState({
    timesheets,
  });

  useEffect(() => {
    setSelected([]);
    setRefresh(false);
  }, [refresh]);

  useEffect(() => {
    setState((state) => ({
      ...state,
      timesheets,
    }));
  }, [timesheets]);

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  const handleModalClose = () => {
    setShowModal({ ...showModal, show: false, status: "" });
    setRefresh(true);
  };

  const handleClientApproveDeclineModalShow = (row) => {
    setShowModal({
      ...showModal,
      show: true,
      status: "Approved",
      isClient: true,
    });
    setSelected([row.id]);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, timesheets.length - page * rowsPerPage);

  var rows = state.timesheets;

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <EnhancedTableToolbar
          numSelected={selected.length}
          title={"Timesheets"}
          selectedTimesheets={selected}
          setSelectedTimesheets={setSelected}
          timesheetTable={true}
        />
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={"medium"}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              headCells={t1HeadCells}
              rowCount={rows.length}
              timesheetTable={true}
            />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.id);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.id}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          color={"default"}
                          checked={isItemSelected}
                          onClick={(event) => handleClick(event, row.id)}
                          inputProps={{ "aria-labelledby": labelId }}
                        />
                      </TableCell>

                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                        padding="none"
                      >
                        {row.employee.user.first_name}{" "}
                        {row.employee.user.last_name}{" "}
                      </TableCell>

                      <TableCell align="right">
                        {readableDateTime(row.start_time)}
                      </TableCell>
                      <TableCell align="right">
                        {readableDateTime(row.end_time)}
                      </TableCell>

                      <TableCell align="right">
                        {readableDateTime(row.timesheet.clock_in_time)}
                      </TableCell>

                      <TableCell align="right">
                        {row.timesheet.human_readable_location_clock_in}
                      </TableCell>

                      <TableCell align="right">
                        {readableDateTime(row.timesheet.clock_out_time)}
                      </TableCell>

                      <TableCell align="right">
                        {row.timesheet.human_readable_location_clock_out}
                      </TableCell>

                      <TableCell align="right">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {row.timesheet.client_approval_status !==
                          "Pending" ? (
                            row.timesheet.client_approval_status
                          ) : !showModal.show ? (
                            <div>
                              <button
                                type="button"
                                class="btn btn-outline-primary"
                                onClick={() => {
                                  handleClientApproveDeclineModalShow(row);
                                }}
                              >
                                Approve/Decline
                              </button>
                            </div>
                          ) : (
                            <ConfirmModal
                              show={showModal.show}
                              handleClose={handleModalClose}
                              status={showModal.status}
                              isClient={showModal.isClient}
                              rows={rows}
                              id={selected}
                              dispatch={dispatch}
                              userToken={userToken}
                              pendingPlacements={pendingPlacements}
                            />
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 25, 50, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
};

export default connect()(ClientTimesheetTable);
